/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'guest-user-for-popup',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    blurbOfGuestPopupClosed(){
      bus.$emit('guestUserPopupStateBus', false);
      document.body.classList.remove('popup_open_body')
    }
  }
}